// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import TagUnauthorizeSvg from '@rsuite/icon-font/lib/application/TagUnauthorize';
var TagUnauthorize = createSvgIcon({
  as: TagUnauthorizeSvg,
  ariaLabel: 'tag unauthorize',
  category: 'application',
  displayName: 'TagUnauthorize'
});
export default TagUnauthorize;